import http from "../httpService";
import {getBaseUrl} from "../../config";


export const updatePassword = data => {

  return http.put(
    `${getBaseUrl()}/change_password`,
    data
  );
};

export const updateForgotPassword = data => {

  return http.put(
    `${getBaseUrl()}/forgot_password`,
    data
  );
};

